<template>
  <div class="page-header min-vh-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8 text-center mx-auto">
          <div class="error-container">
            <h2 class="mt-4">{{ t('General.NotFound.Title') }}</h2>
            <p class="lead text-body mb-5">{{ t('General.NotFound.Text') }}</p>
            <router-link to="/" class="btn bg-gradient-primary mt-4">
              {{ t('General.NotFound.BackToHome') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';

export default {
  name: 'NotFound',
  setup() {
    const { t } = useI18n();
    return { t };
  }
};
</script>

<style scoped>
.error-container {
  padding: 3rem 1.5rem;
}
.display-1 {
  font-size: 8rem;
  font-weight: 700;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
}
</style>
